export default __webpack_public_path__ + "static/media/cancelVisit.20249c66.svg";